window.SlatCalculator = {
  calculate: function (layout, input) {
    if (layout === 'slat_horizontal') {
      return this.calculateHorizontal(input);
    }
    if (layout === 'slat_vertical') {
      return this.calculateVertical(input);
    }
    if (layout === 'slat_horizontal_gate') {
      return this.calculateGate(input);
    }
    if (layout === 'slat_vertical_gate') {
      return this.calculateVerticalGate(input);
    }
    if (layout === 'slat_horizontal_gate_panel') {
      return this.calculateHorizontalGateAndPanel(input);
    }
    if (layout === 'slat_vertical_gate_panel') {
      return this.calculateVerticalGateAndPanel(input);
    }
  },

  calculateHorizontal: function (input) {
    const panels = Array.isArray(input.panels)
      ? input.panels
      :[
        {
          width: input.panelWidth / input.panelCount,
          height: input.panelHeight,
          quantity: input.panelCount
        }
      ];
    const gap = input.gap;
    //Slat
    const slatPieces = [];
    panels.forEach(function (panel) {
      const slatRows = Math.floor((panel.height + gap) / (65 + gap));
      for(let i = 0; i < slatRows * panel.quantity; i++){
        slatPieces.push(panel.width);
      }
    });
    const slatRawMaterial = window.CutOptimizer.optimize(slatPieces, 5800);
    //Post
    const postPieces = [];
    let postQuantity = 0;
    panels.forEach(function (panel) {
      if (panel.addPost) {
        const groupPostQuantity = panel.quantity + 1;
        postQuantity += groupPostQuantity;
        for (let i = 0; i < groupPostQuantity; i++) {
          postPieces.push(panel.height);
        }
      }
    });
    let postRawMaterial = 0;
    if (postPieces.length > 0) {
      postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    }
    //Concealed Fixing Rail
    const concealedFixingRailPieces = [];
    let concealedFixingRailQuantity = 0;
    panels.forEach(function(panel) {
      const groupRailQuantity = panel.quantity * 2;
      concealedFixingRailQuantity += groupRailQuantity;
      for (let i = 0; i < groupRailQuantity; i++) {
        concealedFixingRailPieces.push(panel.height);
      }
    });
    const concealedFixingRailRawMaterial = window.CutOptimizer.optimize(concealedFixingRailPieces, 5800);
    //Concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    panels.forEach(function (panel){
      const groupCoverQuantity = panel.quantity * 2;
      for (let i = 0; i < groupCoverQuantity; i++) {
        concealedFixingCoverPieces.push(panel.height);
      }
      if (panel.width > 1500) {
        for (let i = 0; i < panel.quantity; i++) {
          concealedFixingCoverPieces.push(panel.height);
        }
      }
    });
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Concealed Fix Center
    const concealedFixCenterPieces = [];
    let concealedFixCenterRawMaterial = 0;
    let concealedFixCenterQuantity = 0;
    panels.forEach(function(panel) {
      if (panel.width > 1500) {
        concealedFixCenterQuantity += panel.quantity;
        for (let i = 0; i < panel.quantity; i++) {
          concealedFixCenterPieces.push(panel.height);
        }
      }
    });
    if (concealedFixCenterPieces.length > 0) {
      concealedFixCenterRawMaterial = window.CutOptimizer.optimize(concealedFixCenterPieces, 5800);
    }
    //Channel Infill
    const channelInfillPieces = [];
    panels.forEach(function (panel){
      const channelInfillRows = Math.floor((panel.height + gap) / (65 + gap));
      const channelInfillQuantity = channelInfillRows * panel.quantity * 2;
      for (let i = 0; i < channelInfillQuantity; i++) {
        channelInfillPieces.push(gap);
      }
    });
    const channelInfillRawMaterial = window.CutOptimizer.optimize(channelInfillPieces, 5800);
    //Post Cap
    const postCapQuantity = postQuantity;
    //Channel Cap
    let channelCapQuantity = 0;
    panels.forEach(function (panel) {
      channelCapQuantity += panel.quantity * 2;
    });
    //Concealed Center Support Caps 
    const centerCapQuantity = concealedFixCenterQuantity;
    //Screw
    let screwQuantity = 0;
    panels.forEach(function (panel) {
      const slatRows = Math.floor((panel.height + gap) / (65 + gap));
      let screwPerRow = 2;
      
      if (!panel.addPost && panel.width > 1500) {
        screwPerRow = 3;
      }
      if (panel.addPost && panel.width <= 1500) {
        screwPerRow = 4;
      }
      if (panel.addPost && panel.width > 1500) {
        screwPerRow = 5;
      }
      const panelScrewQuantity = slatRows * screwPerRow * panel.quantity;
      panel.screwQuantity = panelScrewQuantity;
      screwQuantity += panelScrewQuantity;
    });
    const screwPackQuantity = Math.ceil(screwQuantity / 100);
    //Breakdown Detail
    const panelDetails = [];
    panels.forEach(function (panel) {
      const slatRows = Math.floor((panel.height + gap) / (65 + gap));
      const railQuantityPerPanel = 2;
      panelDetails.push(
        window.FencingDetailBuilder.createHorizontalSlat(
          panel,
          gap,
          slatRows,
          railQuantityPerPanel,
          panel.screwQuantity
        )
      );
    });

    const materialResults = [
      { name: 'Slat', qty: slatRawMaterial },
      { name: 'Concealed Fixing Rail', qty: concealedFixingRailRawMaterial },
      { name: 'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      { name: 'Channel Infill', qty: channelInfillRawMaterial },
      { name: 'Channel Cap', qty: channelCapQuantity },
      { name: 'Screw', qty: screwPackQuantity }
    ];
     if (concealedFixCenterRawMaterial > 0) {
        materialResults.splice(5, 0, 
          {name:'Conceal Fix Center', qty: concealedFixCenterRawMaterial },
          {name:'Conceal Fix Center Cap', qty: centerCapQuantity }
        );
      }
     if (postRawMaterial > 0) {
        materialResults.splice(1, 0,
          { name: 'Post', qty: postRawMaterial }
        );
      }
     if (postCapQuantity > 0) {
        materialResults.push(
          { name: 'Post Cap', qty: postCapQuantity }
        );
      }
    materialResults.details = panelDetails;

    return materialResults;
  },

  calculateVertical: function (input) {
    const panels = Array.isArray(input.panels)
      ? input.panels
      : [
          {
            width: input.panelWidth / input.panelCount,
            height: input.panelHeight,
            quantity: input.panelCount
          }
      ];
    const gap = input.gap;
    //Slat
    const slatPieces = [];
    panels.forEach(function (panel) {
      const slatColumns = Math.floor((panel.width + gap) / (65 + gap));
      for (let i = 0; i < slatColumns * panel.quantity; i++) {
        slatPieces.push(panel.height);
      }
    });
    const slatRawMaterial = window.CutOptimizer.optimize(slatPieces, 5800);
    //Post
    const postPieces = [];
    let postQuantity = 0;
    panels.forEach(function (panel) {
      if (panel.addPost) {
        const verticalPostQuantity = panel.quantity + 1;
        postQuantity += verticalPostQuantity;
        for (let i = 0; i < verticalPostQuantity; i++){
          postPieces.push(panel.height);
        }
        for (let i = 0; i < panel.quantity * 2; i++) {
          postPieces.push(panel.width);
        }
      }
    });
    let postRawMaterial = 0;
    if (postPieces.length > 0){
      postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    }
    //Concealed Fixing Rail
    const concealedFixingRailPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity; i++) {
        concealedFixingRailPieces.push(panel.width);
        concealedFixingRailPieces.push(panel.width);
        concealedFixingRailPieces.push(panel.height);
        concealedFixingRailPieces.push(panel.height);
      }
    });
    const concealedFixingRailRawMaterial = window.CutOptimizer.optimize(concealedFixingRailPieces, 5800);
    //Concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity; i++) {
        concealedFixingCoverPieces.push(panel.width);
        concealedFixingCoverPieces.push(panel.width);
        concealedFixingCoverPieces.push(panel.height);
        concealedFixingCoverPieces.push(panel.height);
      }
    });
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Channel Infill
    const channelInfillPieces = [];
    panels.forEach(function (panel) {
      const channelInfillColumns = Math.floor((panel.width + gap) / (65 + gap));
      for (let i = 0; i < channelInfillColumns * panel.quantity * 2; i++) {
        channelInfillPieces.push(gap);
      }
    });
    const channelInfillRawMaterial = window.CutOptimizer.optimize(channelInfillPieces, 5800);
    //Post Cap
    const postCapQuantity = postQuantity;
    //Screw
    let screwQuantity = 0;
    panels.forEach(function (panel) {
      const slatColumns = Math.floor( (panel.width + gap) / (65 + gap) );
      const verticalFixingPoints = Math.floor( panel.height / 65 );
      let panelScrewQuantity = 0;
      if (panel.addPost) {
        panelScrewQuantity = (slatColumns * 4) + (verticalFixingPoints * 4);
      } else {
        panelScrewQuantity = (slatColumns * 2) + (verticalFixingPoints * 2);
      }
      panel.screwQuantity = panelScrewQuantity * panel.quantity;
      screwQuantity += panel.screwQuantity;
    });
    const screwPackQuantity = Math.ceil(screwQuantity / 100);
    //Breakdown Detail
    const panelDetails = [];
    panels.forEach(function (panel) {
      const slatColumns = Math.floor((panel.width + gap) / (65 + gap));
      panelDetails.push(
        window.FencingDetailBuilder.createVerticalSlat(
          panel,
          gap,
          slatColumns,
          panel.screwQuantity
        )
      );
    });

    const materialResults = [
      { name:'Slat', qty: slatRawMaterial },
      { name:'Concealed Fixing Rail', qty: concealedFixingRailRawMaterial },
      { name:'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      { name:'Channel Infill', qty: channelInfillRawMaterial },
      { name:'Screw', qty: screwPackQuantity },
    ];
     if (postRawMaterial > 0) {
      materialResults.splice(1, 0,
        { name:'Post', qty: postRawMaterial }
      );
     }
     if (postCapQuantity > 0) {
      materialResults.push(
        { name:'Post Cap', qty: postCapQuantity }
      );
     }
    materialResults.details = panelDetails;

    return materialResults;
  },

  calculateGate: function(input){
    const gateWidth = input.panelWidth;
    const gateHeight = input.panelHeight;
    const gap = input.gap;
    const gateCount = input.panelCount;
    const gateOption = input.gateOption;
    const gateLeafCount =
      gateOption === 'double_gate'
        ? gateCount * 2
        : gateCount;
    const singleGateLeafWidth = gateWidth / gateLeafCount;

    //slat
    const slatPieces = [];
    const gateSlatRows = Math.floor((gateHeight + gap) / (65 + gap));
    for (let i = 0; i < gateSlatRows * gateLeafCount; i++) {
      slatPieces.push(singleGateLeafWidth);
    }
    const gateSlatRawMaterial = window.CutOptimizer.optimize(slatPieces, 5800);
    //Gate Frame
    const gateFramePieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(singleGateLeafWidth);
      gateFramePieces.push(singleGateLeafWidth);
    }
    const gateFrameRawMaterial = window.CutOptimizer.optimize(gateFramePieces, 5800);
    //Concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
    }
    if (singleGateLeafWidth > 1500) {
      for (let i = 0; i < gateLeafCount; i++) {
        concealedFixingCoverPieces.push(gateHeight);
      }
    }
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Concealed Fix Center
    const concealedFixCenterPieces = [];
    let concealedFixCenterRawMaterial = 0;
    let concealedFixCenterQuantity = 0;
    if (singleGateLeafWidth > 1500) {
      for (let i = 0; i < gateLeafCount; i++) {
        concealedFixCenterPieces.push(gateHeight);
        concealedFixCenterQuantity += 1;
      }
    }
    if (concealedFixCenterPieces.length > 0) {
      concealedFixCenterRawMaterial = window.CutOptimizer.optimize(concealedFixCenterPieces, 5800);
    }
    //Channel Infill
    const channelInfillPieces = [];
    const channelInfillRows = Math.floor((gateHeight + gap) / (65 + gap));
    for (let i = 0; i < channelInfillRows * gateLeafCount * 2; i++) {
      channelInfillPieces.push(gap);
    }
    const channelInfillRawMaterial = window.CutOptimizer.optimize(channelInfillPieces, 5800);
    //Gate Frame Corner
    const gateFrameCornerQuantity = gateLeafCount * 4; 
    //Gate Post
    const postPieces = [];
    const postQuantity = gateCount * 2;
    for (let i = 0; i < postQuantity; i++) {
      postPieces.push(gateHeight);
    }
    const postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    //Gate Post cap
    const postCapQuantity = postQuantity;
    //Concealed Center Support Caps  
    const centerCapQuantity = concealedFixCenterQuantity;
    //Screw
    let screwQuantity = 0;
    const gateWidthFixPoints = Math.floor(singleGateLeafWidth / 65);
    if (gateOption === 'no_post' || gateOption === 'single_gate') {
      if (singleGateLeafWidth > 1500) {
        screwQuantity = (gateSlatRows * 3) + (gateWidthFixPoints * 2);
      } else {
        screwQuantity = (gateSlatRows * 2) + (gateWidthFixPoints * 2);
      }
    }
    if (gateOption === 'double_gate') {
      if (singleGateLeafWidth > 1500) {
        screwQuantity = (gateSlatRows * 6) + (gateWidthFixPoints * 4);
      } else {
        screwQuantity = (gateSlatRows * 4) + (gateWidthFixPoints * 4);
      }
    }
    screwQuantity *= gateCount;
    const screwPackQuantity = Math.ceil(screwQuantity / 100);
    //Breakdom Detail
    const panelDetails = [];
    const gatePanel = {
      width: gateWidth / gateCount,
      height: gateHeight,
      quantity: gateCount
    };
    const gateLeafQuantityPerGate = gateOption === 'double_gate'
      ? 2
      : 1;
    const slatQuantityPerGate = gateSlatRows * gateLeafQuantityPerGate;
    panelDetails.push(
      window.FencingDetailBuilder.createHorizontalGate(
        gatePanel,
        gap,
        slatQuantityPerGate,
        singleGateLeafWidth,
        gateLeafQuantityPerGate,
        screwQuantity,
      )
    );

    const materialResults=[
      {name:'Slat', qty: gateSlatRawMaterial },
      {name:'Gate Frame', qty: gateFrameRawMaterial },
      {name:'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      {name:'Channel Infill', qty: channelInfillRawMaterial },
      {name:'Gate Frame Corner', qty: gateFrameCornerQuantity },
      {name:'Screw', qty: screwPackQuantity},
    ];
    if (concealedFixCenterRawMaterial > 0 ) {
      materialResults.splice(3, 0,
        {name:'Conceal Fix Center', qty: concealedFixCenterRawMaterial },
        {name:'Conceal Fix Center Cap', qty: centerCapQuantity }
      );
    }
    if(gateOption === 'single_gate'){
        materialResults.push(
          {name:'Post', qty: postRawMaterial },
          {name:'Post Cap', qty: postCapQuantity }
        );
    }
    if(gateOption === 'double_gate'){
        materialResults.push(
          {name:'Post', qty: postRawMaterial },
          {name:'Post Cap', qty: postCapQuantity }
        );
    }
    materialResults.details = panelDetails;
         
    return materialResults;
  },

  calculateVerticalGate: function(input){
    const gateWidth = input.panelWidth;
    const gateHeight = input.panelHeight;
    const gap = input.gap;
    const gateCount = input.panelCount;
    const gateOption = input.gateOption;
    const gateLeafCount =
      gateOption === 'double_gate'
        ? gateCount * 2
        : gateCount;

    const singleGateLeafWidth = gateWidth / gateLeafCount;

    //slat
    const slatPieces = [];
    const gateSlatColumns = Math.floor((singleGateLeafWidth + gap) / (65 + gap));
    for (let i = 0; i < gateSlatColumns * gateLeafCount; i++) {
      slatPieces.push(gateHeight);
    }
    const slatRawMaterial = window.CutOptimizer.optimize(slatPieces, 5800);
    //Gate Frame
    const gateFramePieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(singleGateLeafWidth);
      gateFramePieces.push(singleGateLeafWidth);
    }
    const gateFrameRawMaterial = window.CutOptimizer.optimize(gateFramePieces, 5800);
    //Concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
    }
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Channel Infill
    const channelInfillPieces = [];
    const channelInfillColumns = Math.floor((singleGateLeafWidth + gap) / (65 + gap));
    for (let i = 0; i < channelInfillColumns * gateLeafCount * 2; i++) {
      channelInfillPieces.push(gap);
    }
    const channelInfillRawMaterial = window.CutOptimizer.optimize(channelInfillPieces, 5800);
    //Gate Frame Corner
    const gateFrameCornerQuantity = gateLeafCount * 4; 
    //Post 
    const postPieces = [];
    const postQuantity = gateCount * 2;
    for (let i = 0; i < postQuantity; i++) {
      postPieces.push(gateHeight);
    }
    const postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    //Post Cap
    const postCapQuantity = postQuantity;
    //Screw
    let screwQuantity = 0;
    const gateHeightFixPoints = Math.floor(gateHeight / 65);
    if ( gateOption === 'no_post' || gateOption === 'single_gate') {
      screwQuantity = (gateSlatColumns * 2) + (gateHeightFixPoints * 2);
    }
    if (gateOption === 'double_gate') {
      screwQuantity = (gateSlatColumns * 4) + (gateHeightFixPoints * 4);
    }
    screwQuantity *= gateCount;
    const screwPackQuantity = Math.ceil(screwQuantity / 100);
    //Breakdown Detail
    const panelDetails = [];
    const gatePanel = {
      width: gateWidth / gateCount,
      height: gateHeight,
      quantity: gateCount
    };
    const gateLeafQuantityPerGate = gateOption === 'double_gate'
      ? 2
      : 1;
    const slatQuantityPerGate = gateSlatColumns * gateLeafQuantityPerGate;
    panelDetails.push(
      window.FencingDetailBuilder.createVerticalGate(
        gatePanel,
        gap,
        slatQuantityPerGate,
        gateHeight,
        singleGateLeafWidth,
        gateLeafQuantityPerGate,
        screwQuantity
      )
    );

    const materialResults=[
      {name:'Slat', qty: slatRawMaterial },
      {name:'Gate Frame', qty: gateFrameRawMaterial },
      {name:'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      {name:'Channel Infill', qty: channelInfillRawMaterial },
      {name:'Gate Frame Corner', qty: gateFrameCornerQuantity },
      {name:'Screw', qty: screwPackQuantity},
    ];
    if (gateOption === 'single_gate'){
      materialResults.push(
        {name:'Post', qty: postRawMaterial },
        {name:'Post Cap', qty: postCapQuantity },
      );
    }
    if (gateOption === 'double_gate'){
      materialResults.push(
        {name:'Post', qty: postRawMaterial },
        {name:'Post Cap', qty: postCapQuantity }
      );
    }
   materialResults.details = panelDetails;

   return materialResults;
  },

  calculateHorizontalGateAndPanel: function(input){
    const gateWidth = input.panelWidth;
    const gateHeight = input.panelHeight;
    const gateGap = input.gap;
    const gateCount = input.panelCount;
    
    const panels = [];
    if (
      input.extraPanelWidth > 0 &&
      input.extraPanelHeight > 0 &&
      input.extraPanelCount > 0
    ) {
      panels.push({
        width: input.extraPanelWidth / input.extraPanelCount,
        height: input.extraPanelHeight,
        quantity: input.extraPanelCount,
        addPost: input.extraAddPost === true,
        addFrame: input.extraAddFrame === true
      });
    }

    if (Array.isArray(input.otherPanels)){
      input.otherPanels.forEach(function(panel) {
        panels.push(panel);
      });
    }
    const gateOption = input.gateOption;
    const gateLeafCount =
      gateOption === 'double_gate'
        ? gateCount * 2
        : gateCount;
    const singleGateLeafWidth = gateWidth / gateLeafCount;
    //Slat
    const slatPieces = [];
    const gateSlatRows = Math.floor((gateHeight + gateGap) / (65 + gateGap));
    for (let i = 0; i < gateSlatRows * gateLeafCount; i++) {
      slatPieces.push(singleGateLeafWidth);
    }
    panels.forEach(function(panel) {
      const panelSlatRows = Math.floor((panel.height + gateGap) / (65 + gateGap));
      for (let i = 0; i < panelSlatRows * panel.quantity; i++ ){
        slatPieces.push(panel.width);
      }
    });
    const slatRawMaterial = window.CutOptimizer.optimize(slatPieces, 5800);
    //Gate Frame
    const gateFramePieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(singleGateLeafWidth);
      gateFramePieces.push(singleGateLeafWidth);
    }
    const gateFrameRawMaterial = window.CutOptimizer.optimize(gateFramePieces, 5800);
    //Post
    const postPieces = [];
    const includeGatePost =
      gateOption === 'single_gate' ||
      gateOption === 'double_gate';
    const gatePostQuantity = includeGatePost
      ? gateCount * 2
      : 0;
    for (let i = 0; i < gatePostQuantity; i++) {
      postPieces.push(gateHeight);
    }
    let panelPostQuantity = 0;
    panels.forEach(function (panel) {
      if (panel.addPost) {
        const groupPostQuantity = panel.quantity + 1;
        panelPostQuantity += groupPostQuantity;
        for (let i = 0; i < groupPostQuantity; i++) {
          postPieces.push(panel.height);
        }
      }
    });
    let postRawMaterial = 0;
    if (postPieces.length > 0) {
      postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    }
    //Concealed Fixing Rail
    const concealedFixingRailPieces = [];
    let concealedFixingRailQuantity = 0;
    panels.forEach(function(panel) {
      const groupRailQuantity = panel.quantity * 2;
      concealedFixingRailQuantity += groupRailQuantity;
      for (let i = 0; i < groupRailQuantity; i++) {
        concealedFixingRailPieces.push(panel.height);
      }
    });
    const concealedFixingRailRawMaterial = window.CutOptimizer.optimize(concealedFixingRailPieces, 5800);
    //Concealed Fixing Cover
    const concealedFixingCoverPieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
    }
    if (singleGateLeafWidth > 1500) {
      for (let i = 0; i < gateLeafCount; i++) {
        concealedFixingCoverPieces.push(gateHeight);
      }
    }
    panels.forEach(function (panel) {
      for (let i = 0; i < panel.quantity * 2; i++) {
        concealedFixingCoverPieces.push(panel.height);
      }
      if (panel.width > 1500) {
        for (let i = 0; i < panel.quantity; i++) {
          concealedFixingCoverPieces.push(panel.height);
        }
      }
    });
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //concealed Fix Center
    const concealedFixCenterPieces = [];
    let concealedFixCenterRawMaterial = 0;
    let concealedFixCenterQuantity = 0;
    let concealedFixCenterCapQuantity = 0;
    
    if (singleGateLeafWidth > 1500) {
      concealedFixCenterQuantity += gateLeafCount;
      concealedFixCenterCapQuantity += gateLeafCount;
      for (let i = 0; i < gateLeafCount; i++) {
        concealedFixCenterPieces.push(gateHeight);
      }
    }
    panels.forEach(function (panel) {
      if (panel.width > 1500) {
        concealedFixCenterQuantity += panel.quantity;
        concealedFixCenterCapQuantity += panel.quantity;
        for (let i = 0; i < panel.quantity; i++) {
          concealedFixCenterPieces.push(panel.height);
        }
      }
    });
    if (concealedFixCenterPieces.length > 0) {
      concealedFixCenterRawMaterial = window.CutOptimizer.optimize(concealedFixCenterPieces, 5800);
    }
    //Channel Infill
    const channelInfillPieces = [];
    const gateChannelInfillRows = Math.floor((gateHeight + gateGap) / (65 + gateGap));
    for (let i = 0; i < gateChannelInfillRows * gateLeafCount * 2; i++) {
      channelInfillPieces.push(gateGap);
    }
    panels.forEach(function(panel) {
      const panelChannelInfillRows = Math.floor((panel.height + gateGap) / (65 + gateGap));
      for (let i = 0; i < panelChannelInfillRows * panel.quantity * 2; i++){
        channelInfillPieces.push(gateGap);
      }
    });
    const channelInfillRawMaterial = window.CutOptimizer.optimize(channelInfillPieces, 5800);

    //Gate Frame Corner
    const gateFrameCornerQuantity = gateLeafCount * 4;
    //Post Caps
    const postCapQuantity = gatePostQuantity + panelPostQuantity;
    //Channel Caps
    const channelCapQuantity = concealedFixingRailQuantity;
    //Conceal Fix Center Cap
    const centerCapQuantity = concealedFixCenterCapQuantity;
    //Screw
    let gateScrewQuantity = 0;
    const gateWidthFixPoints = Math.floor(singleGateLeafWidth / 65);
    if (gateOption === 'no_post' || gateOption === 'single_gate') {
      if (singleGateLeafWidth > 1500) {
        gateScrewQuantity = (gateSlatRows * 3) + (gateWidthFixPoints * 2);
      } else {
        gateScrewQuantity = (gateSlatRows * 2) + (gateWidthFixPoints * 2);
      }
    }
    if (gateOption === 'double_gate') {
      if (singleGateLeafWidth > 1500) {
        gateScrewQuantity = (gateSlatRows * 6) + (gateWidthFixPoints * 4);
      } else {
        gateScrewQuantity = (gateSlatRows * 4) + (gateWidthFixPoints * 4);
      }
    }

    gateScrewQuantity *= gateCount;

    let panelScrewQuantity = 0;
    panels.forEach(function (panel) {
      const panelSlatRows = Math.floor((panel.height + gateGap) / (65 + gateGap));
    
    let screwPerRow = 2;
    if (!panel.addPost && panel.width > 1500) {
      screwPerRow = 3;
    }
    if (panel.addPost && panel.width <= 1500) {
      screwPerRow = 4;
    }
    if (panel.addPost && panel.width > 1500) {
      screwPerRow = 5;
    }
    const currentPanelScrewQuantity = panelSlatRows * screwPerRow * panel.quantity;
    panel.screwQuantity = currentPanelScrewQuantity;
    panelScrewQuantity += currentPanelScrewQuantity;
    });
    const screwQuantity = gateScrewQuantity + panelScrewQuantity; 
    const screwPackQuantity = Math.ceil(screwQuantity / 100);
    //Breakdown Detail
    const panelDetails = [];
    const gatePanel = {
      width: gateWidth / gateCount,
      height: gateHeight,
      quantity: gateCount
    };
    const gateLeafQuantityPerGate = gateOption === 'double_gate'
      ? 2
      : 1;
    const gateSlatQuantityPerGate = gateSlatRows * gateLeafQuantityPerGate;
    const gateDetail = 
      window.FencingDetailBuilder.createHorizontalGate(
        gatePanel,
        gateGap,
        gateSlatQuantityPerGate,
        singleGateLeafWidth,
        gateLeafQuantityPerGate,
        gateScrewQuantity
      );
    gateDetail.detailName = 'Gate';
    gateDetail.detailUnit = 'gate';
    panelDetails.push (gateDetail);
    panels.forEach(function (panel, index) {
      const panelSlatRows = Math.floor((panel.height + gateGap) / (65 + gateGap));
      const railQuantityPerPanel = 2;
      const panelDetail = 
        window.FencingDetailBuilder.createHorizontalSlat(
          panel,
          gateGap,
          panelSlatRows,
          railQuantityPerPanel,
          panel.screwQuantity
        );
      panelDetail.detailName = `Panel ${index + 1}`;
      panelDetail.detailUnit = `panel`;
      panelDetails.push(panelDetail);
    });

    const materialResults = [
      {name:'Slat', qty: slatRawMaterial },
      {name:'Gate Frame', qty: gateFrameRawMaterial },
      {name:'Concealed Fixing Rail', qty: concealedFixingRailRawMaterial },
      {name:'Concealed Fixing Cover', qty: concealedFixingCoverRawMaterial },
      {name:'Channel Infill', qty: channelInfillRawMaterial },
      {name:'Gate Frame Corner', qty: gateFrameCornerQuantity },
      {name:'Channel Cap', qty: channelCapQuantity },
      {name:'Screw', qty: screwPackQuantity}
    ];
    if (concealedFixCenterRawMaterial > 0) {
        materialResults.splice(5, 0, 
          {name:'Conceal Fix Center', qty: concealedFixCenterRawMaterial },
          {name:'Conceal Fix Center Cap', qty: centerCapQuantity }
        );
    }
    if (postRawMaterial > 0) {
      materialResults.splice(2, 0,
        {name:'Post', qty: postRawMaterial }
      );
    }
    if (postCapQuantity > 0) {
      materialResults.push(
        {name:'Post Cap', qty: postCapQuantity }
      );
    }
    materialResults.details = panelDetails;

    return materialResults;
  },

  calculateVerticalGateAndPanel: function(input){ 
    const gateWidth = input.panelWidth;
    const gateHeight = input.panelHeight;
    const gateGap = input.gap;
    const gateCount = input.panelCount;

    const panels = [];

    if (
      input.extraPanelWidth > 0 &&
      input.extraPanelHeight > 0 &&
      input.extraPanelCount > 0 
    ) {
      panels.push({
        width: input.extraPanelWidth / input.extraPanelCount,
        height: input.extraPanelHeight,
        quantity: input.extraPanelCount,
        addPost: input.extraAddPost === true,
        addFrame: input.extraAddFrame === true
      });
    }
    if (Array.isArray(input.otherPanels)) {
      input.otherPanels.forEach(function (panel) {
        panels.push(panel);
      });
    }
    const gateOption = input.gateOption;
    const gateLeafCount =
      gateOption === 'double_gate'
        ? gateCount * 2
        : gateCount;
    const singleGateLeafWidth = gateWidth / gateLeafCount;
    //Slat
    const slatPieces =[];
    const gateSlatColumns = Math.floor((singleGateLeafWidth + gateGap) / (65 + gateGap));
    for (let i = 0; i < gateSlatColumns * gateLeafCount; i++){
      slatPieces.push(gateHeight);
    }
    panels.forEach(function (panel) {
      const panelSlatColumns = Math.floor((panel.width + gateGap) / (65 + gateGap));
      for (let i = 0; i < panelSlatColumns * panel.quantity; i++) {
        slatPieces.push(panel.height);
      }
    });
    const slatRawMaterial = window.CutOptimizer.optimize(slatPieces, 5800);
    //Gate Frame
    const gateFramePieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(gateHeight);
      gateFramePieces.push(singleGateLeafWidth);
      gateFramePieces.push(singleGateLeafWidth);
    }
    const gateFrameRawMaterial = window.CutOptimizer.optimize(gateFramePieces, 5800);
    //Post
    const postPieces = [];
    const includesGatePost = 
      gateOption === 'single_gate' ||
      gateOption === 'double_gate';
    const gatePostQuantity = includesGatePost
      ? gateCount * 2
      : 0;
    for (let i = 0; i < gatePostQuantity; i++) {
      postPieces.push(gateHeight);
    }
    let panelPostQuantity = 0;
    panels.forEach(function (panel) {
      if (panel.addPost) {
        const verticalPostQuantity = panel.quantity + 1;
        panelPostQuantity += verticalPostQuantity;
        for (let i = 0; i < verticalPostQuantity; i++) {
          postPieces.push(panel.height);
        }
        for (let i = 0; i < panel.quantity * 2; i++) {
          postPieces.push(panel.width);
        }
      }
    });
    let postRawMaterial = 0;
    if (postPieces.length > 0) {
      postRawMaterial = window.CutOptimizer.optimize(postPieces, 5800);
    }
    //Concealed Fixing Rail
    const concealedFixingRailPieces = [];
    let concealedFixingRailQuantity = 0;
    panels.forEach(function (panel) {
      const groupRailQuantity= panel.quantity * 4;
      concealedFixingRailQuantity += groupRailQuantity;
      for (let i = 0; i < panel.quantity; i++) {
        concealedFixingRailPieces.push(panel.width);
        concealedFixingRailPieces.push(panel.width);
        concealedFixingRailPieces.push(panel.height);
        concealedFixingRailPieces.push(panel.height);
      }
    });
    const concealedFixingRailRawMaterial = window.CutOptimizer.optimize(concealedFixingRailPieces, 5800);
    //Concealed Fixing Cover 
    const concealedFixingCoverPieces = [];
    for (let i = 0; i < gateLeafCount; i++) {
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(gateHeight);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
      concealedFixingCoverPieces.push(singleGateLeafWidth);
    }
    panels.forEach(function (panel){
      for (let i = 0; i < panel.quantity; i++) {
        concealedFixingCoverPieces.push(panel.width);
        concealedFixingCoverPieces.push(panel.width);
        concealedFixingCoverPieces.push(panel.height);
        concealedFixingCoverPieces.push(panel.height);
      }
    });
    const concealedFixingCoverRawMaterial = window.CutOptimizer.optimize(concealedFixingCoverPieces, 5800);
    //Channel Infill
    const channelInfillPieces = [];
    const gateChannelInfillColumns = Math.floor((singleGateLeafWidth + gateGap) / (65 + gateGap));
    for (let i = 0; i < gateChannelInfillColumns * gateLeafCount * 2; i++) {
      channelInfillPieces.push(gateGap);
    }
    panels.forEach(function (panel) {
      const panelChannelInfillColumns = Math.floor((panel.width + gateGap) / (65 + gateGap));
      for (let i = 0; i < panelChannelInfillColumns * panel.quantity * 2; i++) {
        channelInfillPieces.push(gateGap);
      }
    });
    const channelInfillRawMaterial = window.CutOptimizer.optimize(channelInfillPieces, 5800);
    //Gate Frame Corner
    const gateFrameCornerQuantity = gateLeafCount * 4;
    //Post Cap
    const postCapQuantity = gatePostQuantity + panelPostQuantity;
    //Screw
    let gateScrewQuantity = 0;
    const gateHeightFixPoints = Math.floor(gateHeight / 65);
    if (gateOption === 'no_post' || gateOption === 'single_gate'){
      gateScrewQuantity = (gateSlatColumns * 2) + (gateHeightFixPoints * 2);
    }
    if (gateOption === 'double_gate') {
      gateScrewQuantity = (gateSlatColumns * 4) + (gateHeightFixPoints * 4);
    }
    gateScrewQuantity *= gateCount;

    let panelScrewQuantity = 0;
    panels.forEach(function (panel) {
      const panelSlatColumns = Math.floor((panel.width + gateGap) / (65 + gateGap));
      const verticalFixingPoints = Math.floor(panel.height / 65);
      let currentPanelScrewQuantity = 0;
      if (panel.addPost) {
        currentPanelScrewQuantity = (panelSlatColumns * 4) + (verticalFixingPoints * 4);
      } else {
        currentPanelScrewQuantity = (panelSlatColumns * 2) + (verticalFixingPoints * 2);
      }
      currentPanelScrewQuantity *= panel.quantity;
      panel.screwQuantity = currentPanelScrewQuantity;
      panelScrewQuantity += currentPanelScrewQuantity;
    });
    const screwQuantity = gateScrewQuantity + panelScrewQuantity;
    const screwPackQuantity = Math.ceil(screwQuantity /100);
    //Breakdown Detail
    const panelDetails = [];
    const gatePanel = {
      width:gateWidth / gateCount,
      height: gateHeight,
      quantity: gateCount
    };
    const gateLeafQuantityPerGate = gateOption === 'double_gate'
        ? 2
        : 1;
    const gateSlatQuantityPerGate = gateSlatColumns * gateLeafQuantityPerGate;
    const gateDetail = 
      window.FencingDetailBuilder.createVerticalGate(
        gatePanel,
        gateGap,
        gateSlatQuantityPerGate,
        gateHeight,
        singleGateLeafWidth,
        gateLeafQuantityPerGate,
        gateScrewQuantity,
      );
    gateDetail.detailName = 'Gate';
    gateDetail.detailUnit = 'gate';
    panelDetails.push(gateDetail);
    panels.forEach(function (panel, index) {
      const panelSlatColumns = Math.floor((panel.width + gateGap) / (65 + gateGap));
      const panelDetail =
        window.FencingDetailBuilder.createVerticalSlat(
          panel,
          gateGap,
          panelSlatColumns,
          panel.screwQuantity
        );
      panelDetail.detailName = `Panel ${index + 1}`;
      panelDetail.detailUnit = `panel`;
      panelDetails.push(panelDetail);
    });


    const materialResults = [
      {name:'Slat', qty: slatRawMaterial },
      {name:'Gate Frame', qty:gateFrameRawMaterial },
      {name:'Concealed Fixing Rail', qty:concealedFixingRailRawMaterial },
      {name:'Concealed Fixing Cover', qty:concealedFixingCoverRawMaterial },
      {name:'Channel Infill', qty:channelInfillRawMaterial },
      {name:'Gate Frame Corner', qty:gateFrameCornerQuantity },
      {name:'Screw', qty: screwPackQuantity},
    ];
    if (postRawMaterial > 0) {
      materialResults.splice(2, 0,
        {name:'Post', qty:postRawMaterial }
      );
    }
    if (postCapQuantity > 0) {
      materialResults.push(
        {name:'Post Cap', qty:postCapQuantity }
      );
    }
    materialResults.details = panelDetails;

    return materialResults;
  }
};